module.exports = __webpack_public_path__ + "static/media/bh.cf7b1dbb.png";